import { PlanShared } from './../../../general/shared/plan-shared';
import { PersonalAnalysticsService } from './../../../../data/repository/analytics-repository/personal-analystics.service';
import { AddFoodBottomsheetComponent } from './../../add-food-bottomsheet/add-food-bottomsheet.component';
import { PersonalDataService } from './../../../../data/repository/plan-repository/personal-data.service';
import { PeroanlPackagefood } from './../../../../core/model/api-response/persoanl-response-model';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';
import { PersoanlService } from './../../../../data/repository/plan-repository/persoanl.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Perosnlapackages } from 'src/app/core/model/api-response/persoanl-response-model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-add-personal-package',
  templateUrl: './add-personal-package.component.html',
  styleUrls: ['./add-personal-package.component.scss'],
})
export class AddPersonalPackageComponent implements OnInit {
  persoanlPackage: Perosnlapackages[];
  calories: number[];

  dietId: string;
  day: string;
  meal: string;
  isReady: boolean = false;

  constructor(
    private planService: PlanService,
    private route: ActivatedRoute,
    private persoanlService: PersoanlService,
    private persoanlDataService: PersonalDataService,
    private matBottomSheet: MatBottomSheet,
    private calorieCalculator: CalorieCalculator,
    private personalAnalysticsService: PersonalAnalysticsService,
    private planShared: PlanShared
  ) {
    this.day = this.route.snapshot.paramMap.get('day');
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.meal = this.route.snapshot.paramMap.get('meal');
    this.persoanlService.getAllPersonalPackageLogs().then((res) => {
      this.persoanlPackage = res;
      this.isReady = true;
    });
    this.personalAnalysticsService.analyticVisitPersonalPackage();
    if (
      !this.planShared.selectedMeal ||
      !this.planShared.selectedDietDayFoodLogs
    ) {
      this.back();
      return;
    }
  }

  ngOnInit() {}
  goCreatePackage() {
    this.planService.goToPersoanlPackageAdd(false);
  }
  goEditCreatePackage(personalP: Perosnlapackages) {
    this.persoanlDataService.savePackage(personalP);
    this.planService.goToPersoanlPackageAdd(true);
  }
  getPackageCalorie(packages: PeroanlPackagefood[]) {
    return this.calorieCalculator.calculatePackagesCalorie(packages);
  }
  back() {
    this.planService.goBack();
  }
  addPersonalPackage(packageP: Perosnlapackages) {
    this.matBottomSheet.open(AddFoodBottomsheetComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        package: packageP,
        dietId: this.dietId,
        day: this.day,
        meal: this.meal,
        peronalPackage: true,
      },
    });
  }
  gArr(i: number) {
    return new Array(i);
  }
}
